import { useCallback, useEffect, useState } from 'react';
import { SEARCH_DEBOUNCE_MS } from '../constants';
import { useDashboardUI } from '../context';

export const useTemplateFilters = () => {
  const { templateFilters, setTemplateFilters } = useDashboardUI();
  const [localSearch, setLocalSearch] = useState(templateFilters.search || '');

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const normalized = localSearch.trim();
      if (normalized !== templateFilters.search) {
        setTemplateFilters({ search: normalized });
      }
    }, SEARCH_DEBOUNCE_MS);

    return () => clearTimeout(timeoutId);
  }, [localSearch, setTemplateFilters, templateFilters.search]);

  const handleSectionChange = useCallback(
    (value) => {
      setTemplateFilters({ sectionId: value || '' });
    },
    [setTemplateFilters],
  );

  const handleCategoryChange = useCallback(
    (value) => {
      setTemplateFilters({ categoryId: value || '' });
    },
    [setTemplateFilters],
  );

  const resetFilters = useCallback(() => {
    setLocalSearch('');
    setTemplateFilters({ search: '', sectionId: '', categoryId: '' });
  }, [setTemplateFilters]);

  const hasActiveFilters = Boolean(templateFilters.search || templateFilters.sectionId || templateFilters.categoryId);

  return {
    localSearch,
    setLocalSearch,
    templateFilters,
    handleSectionChange,
    handleCategoryChange,
    resetFilters,
    hasActiveFilters,
  };
};

export default useTemplateFilters;
